import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=198f97d2"
import script from "./create-user.vue?vue&type=script&lang=js"
export * from "./create-user.vue?vue&type=script&lang=js"
import style0 from "./create-user.vue?vue&type=style&index=0&id=198f97d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports